module.exports = __webpack_public_path__ + "static/media/1.fb9ddd05.png";